import { all, select, take, takeLatest, put, call, delay } from 'redux-saga/effects';
import { damzOnline } from '../actions/initialization';
// import ddt from '@wix/da-ddt';
import { addDraftAttachment, logUnfurlLink, markUnfurlFinished, markUnfurlResolving, maybeUnfurlLinks } from '../actions/drafts';
import { getIsUnfurlResolving, getUnfurlLogForRoom } from '../selectors/drafts';
import { elmoSaysThisMightBeADeviationUrl } from '@wix/da-shared-react/pkg/utils/deviations';
import { maximumAttachments } from '../../constants';
import { isApiError, requestPuppy } from '@wix/da-http-client';
import { factoryAttachmentFromDeviationAndType } from '../../utils/attachments';
function canPlayLink(link) {
    try {
        const url = new URL(link);
        const hostname = url.hostname.toLowerCase();
        return hostname.includes('youtube.com') || hostname.includes('youtu.be') || hostname.includes('dailymotion.com') || hostname.includes('dai.ly') || hostname.includes('vimeo.com') || hostname.includes('twitch.tv');
    } catch (e) {
        return false;
    }
}
function* fetchDeviations(deviations) {
    if (!deviations || deviations.length === 0) {
        return;
    }
    yield put(markUnfurlResolving());
    // TODO need special endpoint so we get sane types back
    const result = yield call(requestPuppy, {
        method: 'get',
        url: `/deviation/multifetch`,
        params: {
            deviationids: deviations.map((d)=>d.deviationid)
        }
    }, undefined);
    if (result && !isApiError(result)) {
        return result.deviations.map((d)=>factoryAttachmentFromDeviationAndType(d, 'zip') // TODO
        );
    }
    yield put(markUnfurlFinished());
    return [];
}
function* handleLinkUnfurl(action) {
    yield delay(250);
    const unfurlLog = yield select((state)=>getUnfurlLogForRoom(state, action.payload.room_id));
    const unfurlResolving = yield select((state)=>getIsUnfurlResolving(state));
    if (unfurlResolving) {
        return; // Wait for resolve to complete
    }
    // Filter already unfurled
    const linksToConsider = action.payload.links.filter((link)=>link.type === 'url' && !unfurlLog.includes(link.href));
    if (linksToConsider.length === 0) {
        return;
    }
    const deviations = [];
    const videos = [];
    const log = [];
    let count = 0;
    linksToConsider.forEach((link)=>{
        if (count >= maximumAttachments) {
            return;
        }
        const devFetch = elmoSaysThisMightBeADeviationUrl(link.href);
        if (devFetch) {
            deviations.push(devFetch);
            log.push(link.href);
            count++;
        }
        if (canPlayLink(link.href)) {
            videos.push(link.href);
            log.push(link.href);
            count++;
        }
    });
    // Log we have unfurled them
    yield put(logUnfurlLink(action.payload.room_id, log));
    if (videos.length > 0) {
        const toAdd = videos.map((videoHref)=>put(addDraftAttachment({
                isVideo: true,
                link: videoHref
            }, action.payload.room_id)));
        yield all(toAdd);
    }
    const deviationAttachments = yield call(fetchDeviations, deviations);
    if (deviationAttachments && deviationAttachments.length > 0) {
        const toAdd = deviationAttachments.map((att)=>put(addDraftAttachment(att, action.payload.room_id)));
        yield all(toAdd);
    }
}
/**
 * Handles draft related things like unfurling and LS storage
 */ export function* draftsSaga() {
    yield take(damzOnline); // wait for online to happen
    yield all([
        takeLatest(maybeUnfurlLinks, handleLinkUnfurl)
    ]);
}

//# sourceMappingURL=drafts.js.map